import { Component, Input, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { DepositButtonService } from 'src/app/services/cashier/deposit-button.service';
import { EventsService } from 'src/app/services/event/event.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { BalanceModel } from 'src/app/models/balance-model';

@Component({
  selector: 'app-deposit-button',
  templateUrl: './deposit-button.component.html',
  styleUrls: ['./deposit-button.component.scss'],
})
export class DepositButtonComponent implements OnInit {
  @Input() size;
  @Input() type;
  @Input() buttonText;
  @Input() campaignId;
  @Input() depositMethod;
  @Input() navigateBackPage;
  @Input() data?;

  public recievedSelectedBonus;
  public showButton = false;
  public balance: BalanceModel | null = null;

  public pageToRedirect: string;
  public isAuthenticated: boolean = false;
  public showBalance: boolean = true;

  defaultIsTrue = item => item.is_default == true;

  constructor(
    private accountBalanceService: AccountBalanceService,
    private events: EventsService,
    public navigator: Navigator,
    public userSession: UserSessionService,
    public config: ConfigService,
    private responsibleGamingProvider: ResponsibleGamingService,
    private depositButtonService: DepositButtonService,
  ) { }


  ngOnInit() {
    const siteDepositButton = this.accountBalanceService?.showBalance ?? true;
    this.showButton = (!siteDepositButton) ? false : true;
    this.isAuthenticated = this.userSession.isAuthenticated();
    this.verifyAuthAndLoadBalance();

    this.events.subscribe('event:balanceState', this.updateBalanceState.bind(this));
  }

  onDeposit() {
    this.responsibleGamingProvider.getAllPendingLimit().subscribe({
      next: (response: any) => {
        if (response.payload.length !== 0) {
          this.navigator.navigateTo('LimitConfirmationComponent', { forceModal: true }, { callBackFn: () => { this.navigator.navigateTo("DepositMainComponent"); } });
        } else {
          this.depositButtonService.onDeposit(this.campaignId, this.type, this.depositMethod, this.navigateBackPage);
          console.log('No Pending Limit for User')
        }
      },
      error: () => {
        this.depositButtonService.onDeposit(this.campaignId, this.type, this.depositMethod, this.navigateBackPage);
        console.log('Error:  Pending Limit')
      }
    });
  }

  public onPromoDeposit(navigateBackPage?): any {
    this.depositButtonService.onPromoDeposit(this.data, this.isAuthenticated, navigateBackPage);
  }

  //Temprorary for Development
  onDeposits() {
    return this.navigator.navigateTo("DepositPaywithmybankComponent");
  }

  private updateBalanceState(data: any): void {
    this.showBalance = !!data?.show;
    if (data?.code === 'IN_GAME') {
      this.showBalance = false;
    }
  }


  private verifyAuthAndLoadBalance(): void {
    if (this.userSession.isAuthenticated()) {
      this.accountBalanceService.getBalance().subscribe((response: BalanceModel) => {
        this.balance = response;
      });
    }
  }
}
